import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Modal from 'components/Modal';
import Button from 'components/Button';
import SearchInput from 'components/SearchInput';
import Table from 'components/Table';
import { truckersAPI } from 'services/apiRest';
import { actions as toastrActions } from 'react-redux-toastr';
import { useDispatch } from 'react-redux';

const ModalContainer = styled.div`
  padding: 20px;
  min-width: 600px;
  max-width: 800px;
`;

function ModalSelecionarCondutor({ open, onClose, onSelect }) {
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [condutores, setCondutores] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      buscarCondutores();
    }
  }, [open]);

  const buscarCondutores = async () => {
    try {
      setLoading(true);
      // Buscar todos os motoristas (que são os condutores)
      const motoristas = await truckersAPI.listar();
      
      // Converter motoristas para formato de condutor
      const condutoresFormatados = motoristas.map(motorista => ({
        id: motorista.id,
        nome: motorista.name || motorista.nome || '',
        cpf: motorista.cpf || '',
        telefone: motorista.phone || motorista.telefone || '',
        cnh: motorista.cnh || '',
        categoria_cnh: motorista.category_cnh || motorista.categoria_cnh || ''
      }));
      
      setCondutores(condutoresFormatados);
    } catch (error) {
      console.error('Erro ao buscar condutores:', error);
      dispatch(toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Não foi possível carregar os condutores'
      }));
    } finally {
      setLoading(false);
    }
  };

  const filteredCondutores = condutores.filter((condutor) =>
    String(condutor.nome || '').toUpperCase().includes(search.toUpperCase()) ||
    String(condutor.cpf || '').toUpperCase().includes(search.toUpperCase())
  );

  const tableData = filteredCondutores.map((condutor) => ({
    id: condutor.id,
    nome: condutor.nome || '-',
    cpf: condutor.cpf || '-',
    cnh: condutor.cnh || '-',
    categoria: condutor.categoria_cnh || '-',
    telefone: condutor.telefone || '-',
  }));

  const handleSelect = (condutorId) => {
    const condutor = filteredCondutores.find((c) => c.id === condutorId);
    if (condutor && onSelect) {
      onSelect(condutor);
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose} title="Selecionar Condutor">
      <ModalContainer>
        <div style={{ marginBottom: '20px' }}>
          <SearchInput
            onChange={(e) => setSearch(e.target.value)}
            onClear={() => setSearch('')}
            value={search}
            placeholder="Buscar por nome ou CPF..."
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              Carregando condutores...
            </div>
          ) : tableData.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
              Nenhum condutor encontrado. Cadastre motoristas primeiro.
            </div>
          ) : (
            <Table
              columns={[
                { label: 'Nome', id: 'nome' },
                { label: 'CPF', id: 'cpf' },
                { label: 'CNH', id: 'cnh' },
                { label: 'Categoria', id: 'categoria' },
                { label: 'Telefone', id: 'telefone' },
                { label: 'Ações', id: 'actions' },
              ]}
              data={tableData}
              customComponent={{
                actions: (e, item) => (
                  <Button
                    label="Selecionar"
                    onClick={() => handleSelect(item.id)}
                    color="primary"
                    width="100px"
                    height="30px"
                  />
                ),
              }}
            />
          )}
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <Button
            label="Cancelar"
            onClick={onClose}
            color="secondary"
          />
        </div>
      </ModalContainer>
    </Modal>
  );
}

export default ModalSelecionarCondutor;

